import { AppConsole } from './AppConsole';
import { ILoggerStorageEntry } from './ILoggerStorageEntry';

export { AppConsole, ILoggerStorageEntry };
